<template>
<v-card class="base-section-container" elevation="5" shaped outlined>
    <header>
        <v-alert class="mb-0" dense text-color="white">
            <h5>{{ title }}</h5>
        </v-alert>
    </header>
    <v-card-text class="base-section-text">
        <slot name="buscador"></slot>
    </v-card-text>
    <v-card-text>
        <slot></slot>
    </v-card-text>
    <v-card-text>
        <slot name="footer"></slot>
    </v-card-text>
</v-card>
</template>
<script>
    export default {
        props: {
            title: {
                type: String,
                default: 'TITULO DE SECCIÓN'
            }
        }
    }
</script>

<style scoped>

    .v-alert {
        margin: 0 !important;
    }

 
</style>
